import type {
  ChatCompletionMessageFunctionToolCall,
  ChatCompletionMessageParam,
} from 'openai/resources';

export function functionToolCalls(
  message: ChatCompletionMessageParam,
): ChatCompletionMessageFunctionToolCall[] {
  if (message.role !== 'assistant') return [];

  return (
    message.tool_calls?.flatMap((toolCall) =>
      // only function tools are declared, so there cannot be any other kind
      'function' in toolCall ? [toolCall] : [],
    ) ?? []
  );
}
